







import Vue from 'vue';

export default Vue.extend({
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
});
